import React, { useState } from 'react'
import { useEffect } from 'react';
import CommonContainer from "../Container/CommonContainer";
import CommonPagination from '../../Common/CommonPagination';
import * as ParnterLoginTrackingReportService from '../../Services/MHL_Reports/PartnerLoginReportService';
import { FaSearch, FaSpinner, FaEnvelope } from "react-icons/fa";
import toast from 'react-hot-toast';
import { Download, Loader2 } from 'lucide-react';
import Popover from '../../Common/Popper';

const PartnerLoginTrackingReportComponent = () => {
    const [loginData, setLoginData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [isDownloadingReport, setIsDownloadingReport] = useState(false);
    const itemsPerPage = 15;

    const getLoginTrackingData = () => {
        ParnterLoginTrackingReportService.PartnerLoginReport()
            .then(({ data }) => {
                if (data.IsSuccess) {
                    setLoginData(data?.Data);
                } else {
                    setLoginData([]);
                }
            })
            .catch(() => {
                setLoginData([]);
            });
    };

    useEffect(() => {
        getLoginTrackingData();
    }, []);

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
    };

    const filteredLoginData = loginData.filter((data) => {
        const lowerSearch = searchTerm.toLowerCase();
        return (
            data.Partner_Code?.toLowerCase().includes(lowerSearch) ||
            data.Partner_Name?.toLowerCase().includes(lowerSearch) ||
            data.EmailId?.toLowerCase().includes(lowerSearch) ||
            data.Mobile_No?.toString().includes(searchTerm)
        );
    });

    const indexOfLast = currentPage * itemsPerPage;
    const indexOfFirst = indexOfLast - itemsPerPage;
    const currentLoginDate = filteredLoginData.slice(indexOfFirst, indexOfLast);

    const handleDownloadReport = async () => {
        setIsDownloadingReport(true);
        try {
            const response = await ParnterLoginTrackingReportService.DownloadPartnerLoginReport();
            const resData = response.data;

            if (!resData?.IsSuccess || !resData?.Data) {
                toast.error("Failed to download report");
                return;
            }

            const byteCharacters = atob(resData.Data);
            const byteNumbers = new Array(byteCharacters.length);

            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);

            const blob = new Blob([byteArray], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");

            link.href = url;
            link.download = "Partner_Login_Report.xlsx";
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            toast.error("Download failed");
        } finally {
            setIsDownloadingReport(false);
        }
    };

    return (
        <CommonContainer heading="Partner Login Tracking">
            <div className="d-flex flex-column flex-lg-row mb-2 date-search-content gap-2 search-sm" style={{ justifyContent: "space-between" }}>
                <div>
                    <button
                        className="btn custom-sumbitbtn d-flex align-items-center justify-content-center gap-2"
                        onClick={handleDownloadReport}
                        title="Download Report"
                    >
                        {isDownloadingReport ? (
                            <>
                                <FaSpinner className="w-5 h-5 fa-spin" />
                                Downloading...
                            </>
                        ) : (
                            <>
                                <Download size={18} />
                                Download Report
                            </>
                        )}
                    </button>
                </div>
                <div className="search-box" style={{ position: "relative" }}>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search"
                        value={searchTerm}
                        onChange={handleSearch}
                        style={{ paddingRight: "35px", borderRadius: "5px", border: "1px solid #ddd" }}
                    />
                    <button
                        className="btn custom-sumbitbtn d-flex align-items-center justify-content-center search-box-btn"
                        style={{
                            padding: '5px',
                            position: "absolute",
                            right: "0px",
                            height: "35px",
                            width: "45px",
                            top: "50%",
                            borderTopLeftRadius: "0",
                            borderBottomLeftRadius: "0",
                            transform: "translateY(-45%)"
                        }}
                        onClick={() => setCurrentPage(1)}
                    >
                        <FaSearch />
                    </button>
                </div>
            </div>

            <div className="mt-3 mt-lg-2">
                <div className="table-responsive mhl-partner-login-report-table">
                    <table className="table table-bordered custom-table">
                        <thead>
                            <tr>
                                {/* <th>Partner Code</th>
                                <th>Partner Name</th>
                                <th>Payment Type</th> */}
                                <th style={{ width: "22%" }}>Partner Details</th>
                                <th style={{ width: "12%" }}>Created By</th>
                                {/* <th>Active Staff Count</th> */}
                                <th style={{ width: "8%" }}>Staff Details</th>
                                {/* <th style={{ width: "6%" }}>Active Staff</th> */}
                                <th style={{ width: "4%" }}>Total</th>
                                <th style={{ width: "4%" }}>Web</th>
                                <th style={{ width: "4%" }}>Android</th>
                                <th style={{ width: "4%" }}>IOS</th>
                                {/* <th style={{ width: "3%" }}>Created On</th>
                                <th style={{ width: "5%" }}>First Login</th> */}
                                <th style={{ width: "5%" }}>Last Login</th>
                                {/* <th style={{ width: "10%" }}>Is Login</th> */}
                                {/* <th>Created By Email</th> */}
                            </tr>
                        </thead>
                        <tbody style={{ fontSize: "10px" }}>
                            {currentLoginDate?.length > 0 ? (
                                currentLoginDate?.map((data, index) => (
                                    <tr className="patient-list-row" key={index}>
                                        {/* <td>{data?.Partner_Code}</td>
                                        <td>{data?.Partner_Name}</td>
                                        <td>{data?.Payment_Type}</td> */}
                                        <td style={{ textAlign: "left", verticalAlign: "middle", paddingLeft: '15px' }}>
                                            <Popover
                                                content={
                                                    <div style={{ textAlign: "left" }}>
                                                        <p><strong>Payment Type:</strong> {data.Payment_Type}</p>
                                                        <p><strong>Partner Code:</strong> {data.Partner_Code}</p>
                                                        <p><strong>Partner Name:</strong> {data.Partner_Name}</p>
                                                        <p><strong>Created Date:</strong> {data.CreatedOn}</p>
                                                        <p><strong>First Login Date:</strong> {data.First_Login_Date}</p>
                                                    </div>
                                                }
                                            >
                                                {data.Payment_Type === "Rolling Advance" && (
                                                    <><i className="fas fa-battery-full text-success" /> </>
                                                )}
                                                {data.Payment_Type === "Credit" && (
                                                    <><i className="fas fa-credit-card text-success" /> </>
                                                )}
                                                {data.Payment_Type === "Cash" && (
                                                    <><i className="fas fa-money-bill-wave text-warning" /></>
                                                )}
                                                &nbsp;
                                            </Popover>


                                            <b>{data.Partner_Code}</b> - {data.Partner_Name.length > 25 ? `${data.Partner_Name.substring(0, 25)}...` : data.Partner_Name}
                                        </td>
                                        {/* <td>{data?.Active_Staff_Count}</td> */}
                                        {/* <td>{data?.Staff_Onboarded_In_Partner ? "True" : "False"}</td> */}
                                        <td>
                                            <FaEnvelope color='Green' title={data?.CreatedBy_Email} />
                                            &nbsp; {data?.CreatedBy_Name}

                                        </td>
                                        <td>
                                            {data?.Staff_Onboarded_In_Partner && data?.Is_Login ? (
                                                <i className="fas fa-user-check" style={{ color: "green", cursor: "pointer" }} title="Staff Onboarded & Partner Logged In"></i> // Tooltip only on icon
                                            ) : data?.Staff_Onboarded_In_Partner && !data?.Is_Login ? (
                                                <i className="fas fa-user" style={{ color: "green", cursor: "pointer" }} title="Staff Onboarded & Partner Never Logged In"></i> // Tooltip only on icon
                                            ) : (
                                                <i className="fas fa-user-check" style={{ color: "red", cursor: "pointer" }} title="Staff Not Onboarded & Partner Never Logged In"></i> // Tooltip only on icon
                                            )}
                                            {/* {data?.Staff_Onboarded_In_Partner ? "True" : "False"} */}
                                            <b> {data?.Active_Staff_Count ?? 0}</b></td>
                                        <td>{data?.Total_Logins}</td>
                                        <td>{data?.Web_Login_Count}</td>
                                        <td>{data?.Android_Login_Count}</td>
                                        <td>{data?.Ios_Login_Count}</td>
                                        {/* <td>{data?.CreatedOn}</td> */}
                                        {/* <td>{data?.First_Login_Date}</td> */}
                                        <td>{data?.Last_Login_Date}</td>
                                        {/* <td>{data?.Is_Login ? "True" : "False"}</td> */}

                                        {/* <td>{data?.CreatedBy_Email}</td> */}
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="10" className="text-center">
                                        No Data found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {filteredLoginData.length > itemsPerPage && (
                    <CommonPagination
                        pageList={filteredLoginData}
                        currentPage={currentPage}
                        itemsPerPage={itemsPerPage}
                        setCurrentPage={setCurrentPage}
                    />
                )}
            </div>
        </CommonContainer>
    )
}

export default PartnerLoginTrackingReportComponent;
